// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"966f1169","453":"b8d61749","858":"c1ab4036"}[chunkId] + ".chunk.js";
};